import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-paymentmodemodal',
  templateUrl: './paymentmodemodal.component.html',
  styleUrls: ['./paymentmodemodal.component.css']
})
export class PaymentmodemodalComponent implements OnInit {
  bank: any;
  password: any;

  constructor() {
  }

  ngOnInit() {
  }

  back() {

  }

  makePayment() {
    //console.log(this.bank, this.password)
  }
}
